import { SxProps, Theme } from '@mui/material/styles'
import { hoverBaseStyles } from '../base/hoverBase.styles'

export const paymentStyles = {
  root: {
    ...hoverBaseStyles.root,
  } as SxProps<Theme>,

  row: {
    display: 'flex',
    alignItems: 'center',
    gap: 0.75,

    ...hoverBaseStyles.textRegular,
  } as SxProps<Theme>,

  label: {
    color: 'info.main',
  } as SxProps<Theme>,

  value: {
    color: 'gray.64',
    width: 24,
    textAlign: 'center',
  } as SxProps<Theme>,
}
